import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'login', loadComponent: () => import('./features/auth/pages/login/login.component').then(m => m.LoginComponent) },
  { path: 'register', loadComponent: () => import('./features/auth/pages/register/register.component').then(m => m.RegisterComponent) },
  {
    path: 'legal/terms',
    loadComponent: () => import('./features/legal-info/pages/terms-and-conditions-page/terms-and-conditions-page.component').then(m => m.TermsAndConditionsPageComponent),
  },
  {
    path: 'legal/privacy',
    loadComponent: () => import('./features/legal-info/pages/privacy-policy-page/privacy-policy-page.component').then(m => m.PrivacyPolicyPageComponent),
  },
  {
    path: 'dashboard', loadComponent: () => import('./features/dashboard/pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'clients', loadComponent: () => import('./features/clients/pages/clients/clients.component').then(m => m.ClientsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'clients/:uuid', loadComponent: () => import('./features/clients/pages/client-detail/client-detail.component').then(m => m.ClientDetailComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'cases', loadComponent: () => import('./features/cases/pages/cases/cases.component').then(m => m.CasesComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'cases/:uuid', loadComponent: () => import('./features/cases/pages/case-detail/case-detail.component').then(m => m.CaseDetailComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'legal-cases', loadComponent: () => import('./features/legal-cases/pages/legal-cases/legal-cases.component').then(m => m.LegalCasesComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'legal-cases/:uuid', loadComponent: () => import('./features/legal-cases/pages/legal-case-detail/legal-case-detail.component').then(m => m.LegalCaseDetailComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'tasks', loadComponent: () => import('./features/tasks/pages/tasks/tasks.component').then(m => m.TasksComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'tasks/:uuid', loadComponent: () => import('./features/tasks/pages/task-detail/task-detail.component').then(m => m.TaskDetailComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'files', loadComponent: () => import('./features/files/pages/files/files.component').then(m => m.FilesComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'notes', loadComponent: () => import('./features/notes/pages/notes/notes-page.component').then(m => m.NotesPageComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'calendar', loadComponent: () => import('./features/calendar/pages/calendar/calendar.component').then(m => m.CalendarComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'appointments', loadComponent: () => import('./features/appointments/pages/appointments/appointments.component').then(m => m.AppointmentsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'profile', loadComponent: () => import('./features/profile/pages/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: 'dashboard' },
];
